import { ChangeEvent, Dispatch, SetStateAction, useCallback } from 'react'
import { FirebaseCollectionRefType, FirebaseDocRefType } from 'firebase/index'

const useCheckRef = (update: Dispatch<SetStateAction<FirebaseDocRefType[]>>, collection: FirebaseCollectionRefType) => {
  return useCallback(
    (event: ChangeEvent<HTMLInputElement> | string) => {
      const id = typeof event === 'string' ? event : event.target.id
      update((prevState) => {
        // 選択済みの値であれば削除
        if (prevState.some((state) => state.id === id)) {
          return prevState.filter((state) => state.id !== id)
        } else {
          return [...prevState, collection.doc(id)]
        }
      })
    },
    [update]
  )
}

export default useCheckRef
